import { MESSAGE_SHOW } from './types';


export function messageShow(state) {
    return {
        type: MESSAGE_SHOW,
        payload: state
    }
}